import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";

export const GoogleLoginButton = ({ handleError, handleSuccess, type }) => {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const { code } = tokenResponse; // Get the code from the frontend
      const params = {
        code,
        client_id: process.env.REACT_APP_SSO_GOOGLE_CLIENT_ID,
        client_secret: process.env.REACT_APP_SSO_GOOGLE_SECRET,
        redirect_uri: process.env.REACT_APP_SSO_GOOGLE_REDIRECT_URI,
        grant_type: "authorization_code",
      };
      console.log(tokenResponse, "tokenResponse");
      const response = await axios.post(
        "https://oauth2.googleapis.com/token",
        null,
        { params }
      );
      console.log(response.data, "handleSuccess");
      handleSuccess(response.data.id_token); // Call success handler
      // handleSuccess(tokenResponse); // Call success handler
    },
    onError: () => handleError(),
    flow: "auth-code",
    redirect_uri: process.env.REACT_APP_SSO_GOOGLE_REDIRECT_URI,
    responseType: "code",
    isSignedIn: true,
  });

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        login();
      }}
      className="facebook-signin-button"
      style={{
        backgroundColor: type === "webpage" ? "white" : "#db4437",
        justifyContent: type === "webpage" ? "space-evenly" : "flex-start",
        width: type === "webpage" ? "100% " : "",
        padding: type === "webpage" ? "10px " : "",
      }}
    >
      {/* <img
        src="https://developers.google.com/identity/images/g-logo.png"
        alt="Google logo"
        style={{ height: "30px" }}
      /> */}
      <FcGoogle size={30} color="white" style={{ backgroundColor: "white" }} />
      <span
        className={`${type === "popup" && "mx-auto"} inter-font ${
          type === "webpage" ? "text-black" : "text-white"
        }`}
        style={{ fontSize: type === "webpage" ? "23px" : "" }}
      >
        Sign in with Google
      </span>
    </button>
  );
};
